import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class ClaimFileProcessingType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._client_name = init.client_name
    this._created_at = init.created_at
    this._employee_id = init.employee_id
    this._existing_vendor = init.existing_vendor
    this._id = init.id
    this._issue_description = init.issue_description
    this._jira_ticket_link = init.jira_ticket_link
    this._request_source = init.request_source
    this._request_type = init.request_kind
    this._sftp = init.sftp
    this._source_attachments = init.source_attachments
    this._updated_at = init.updated_at
    this._vendor_contact_email = init.vendor_contact_email
    this._vendor_contact_name = init.vendor_contact_name
    this._vendor_contact_phone = init.vendor_contact_phone
    this._vendor_name = init.vendor_label
    this._vendor_type = init.vendor_type
  }

  static shape = {
    client_name: PropTypes.string,
    created_at: PropTypes.string,
    employee_id: PropTypes.string,
    existing_vendor: PropTypes.string,
    id: PropTypes.string,
    issue_description: PropTypes.string,
    jira_ticket_link: PropTypes.string,
    request_source: PropTypes.string,
    request_type: PropTypes.string,
    sftp: PropTypes.string,
    source_attachments: PropTypes.arrayOf(PropTypes.string),
    updated_at: PropTypes.string,
    vendor_contact_email: PropTypes.string,
    vendor_contact_name: PropTypes.string,
    vendor_contact_phone: PropTypes.string,
    vendor_name: PropTypes.string,
    vendor_type: PropTypes.string
  }

  get client_name() {
    return this._client_name
  }

  get created_at() {
    return this._created_at
  }

  get employee_id() {
    return this._employee_id
  }

  get existing_vendor() {
    return this._existing_vendor
  }

  get id() {
    return this._id
  }

  get issue_description() {
    return this._issue_description
  }

  get jira_ticket_link() {
    return this._jira_ticket_link
  }

  get request_source() {
    return this._request_source
  }

  get request_type() {
    return this._request_type
  }

  get sftp() {
    return this._sftp
  }

  get source_attachments() {
    return this._source_attachments
  }

  get updated_at() {
    return this._updated_at
  }

  get vendor_contact_email() {
    return this._vendor_contact_email
  }

  get vendor_contact_name() {
    return this._vendor_contact_name
  }

  get vendor_contact_phone() {
    return this._vendor_contact_phone
  }

  get vendor_name() {
    return this._vendor_name
  }

  get vendor_type() {
    return this._vendor_type
  }
}

export default ClaimFileProcessingType
